export default {
  cart: state => state.cart,
  // cartLocal: () => JSON.parse(localStorage.getItem('cart'))?.items,
  cartLocal: state => state.localCart?.items,
}